import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { BPFDealStatus } from '../../../types';

const DOT_COLOR: Record<BPFDealStatus, string> = {
  [BPFDealStatus.Healthy]: '#12B76A',
  [BPFDealStatus.Hot]: '#EC4899',
  [BPFDealStatus.Stalled]: '#F79009',
  [BPFDealStatus.AtRisk]: '#F04438',
};

const DOT_LABEL: Record<BPFDealStatus, string> = {
  [BPFDealStatus.Healthy]: 'Healthy — recently active',
  [BPFDealStatus.Hot]: 'Hot — close date within 30 days, probability ≥ 50%',
  [BPFDealStatus.Stalled]: 'Stalled — no stage progression in 7–14 days',
  [BPFDealStatus.AtRisk]: 'At Risk — overdue or stuck in stage 14+ days',
};

interface Props {
  status: BPFDealStatus;
}

export const DealStatusDot = ({ status }: Props) => (
  <Tooltip title={DOT_LABEL[status]} placement="right" arrow>
    <Box
      sx={{
        width: '1rem',
        height: '1rem',
        flexShrink: 0,
        cursor: 'default',
        borderRadius: '50%',
        backgroundColor: DOT_COLOR[status],
      }}
    />
  </Tooltip>
);
